module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"top_progressions":"Winners","flop_progressions":"Losers"},"fr":{"top_progressions":"Les plus fortes hausses","flop_progressions":"Les plus fortes baisses"},"de":{"top_progressions":"Die größten Anstiege","flop_progressions":"Die größten Tropfen"}}')
  delete Component.options._Ctor
}
